import { render } from "./CVPCard.vue?vue&type=template&id=41564ec2"
import script from "./CVPCard.vue?vue&type=script&lang=js"
export * from "./CVPCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__